module.exports = __webpack_public_path__ + "static/media/message-translate.007d4ce2.svg";